/**
 * Debug utilities for controlling debug features visibility
 */

/**
 * Check if debug features should be enabled
 * Shows debug features in development or when VITE_ENABLE_DEBUG_TOOLS is explicitly set to true
 */
export function shouldShowDebugFeatures(): boolean {
  return !import.meta.env.PROD || !!import.meta.env.VITE_ENABLE_DEBUG_TOOLS;
}

/**
 * Check if we are in development mode
 */
export function isDevelopment(): boolean {
  return !import.meta.env.PROD;
}

/**
 * Check if debug tools are explicitly enabled via environment variable
 */
export function isDebugToolsEnabled(): boolean {
  return !!import.meta.env.VITE_ENABLE_DEBUG_TOOLS;
}

